var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0091 15.2211C11.487 15.5748 10.8302 15.8695 10.0303 16.1305L8.69982 16.5684C5.35685 17.6462 3.59694 16.7452 2.51067 13.4022L1.43283 10.0761C0.354989 6.73308 1.24758 4.96474 4.59057 3.8869L5.92104 3.44903C6.26628 3.33956 6.59469 3.24693 6.90625 3.18799C6.65363 3.70165 6.45154 4.32478 6.28312 5.04053L5.4579 8.56878C4.63268 12.0886 5.71894 13.8233 9.23032 14.6569L10.645 14.9937C11.1334 15.1116 11.5881 15.1874 12.0091 15.2211Z",
    stroke: "#565656",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.977 3.18814C17.8864 4.19862 18.0464 5.64697 17.5665 7.68476L16.7412 11.2046C16.0339 14.2444 14.6361 15.4739 12.0088 15.2212C11.5878 15.1876 11.1331 15.1118 10.6447 14.9939L9.23002 14.6571C5.7186 13.8234 4.63233 12.0888 5.45756 8.56893L6.28278 5.04068C6.45119 4.32493 6.65329 3.7018 6.90591 3.18814C7.89114 1.15034 9.56685 0.603003 12.3793 1.26823L13.7856 1.59664",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBill);
export default __webpack_public_path__ + "static/media/icon-bill.8ca80e1cfc407d6df8d8fadcdda57c7b.svg";
export { ForwardRef as ReactComponent };